import React from 'react';
import { metricKeys } from '@pulse/metrics';
import { keys, adKeys } from '@components/noc-metric-panel/utils/constants';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import ScopeV2 from '../ThresholdV2/Scope';
import SearchHeader from '../ThresholdV2/SearchHeader';
import { getMetricDisplayName, getMetricShortName } from '@utils/metrics';

export const mainBaseLineColumnV2 = [
  {
    title: '',
    key: keys.BaseLine,
    dataKey: keys.BaseLine.key,
    width: 260,
    frozen: true,
    style: {
      fontSize: '18px',
      position: 'relative',
      top: '10px',
    },
  },
];

export const mainContentColumnV2 = [
  {
    title: '',
    key: keys.RowKeys.key,
    dataKey: keys.RowKeys.key,
    width: 260,
    cellRenderer: (props) => {
      const { cellData } = props;
      return <ScopeV2 text={cellData} />;
    },
    headerRenderer: () => <SearchHeader />,
    frozen: true,
  },
];

const getThresholdBaselineColumns = () =>
  ({
    EI: {
      cols: [
        {
          key: keys.eicombinedMetrics.key,
          width: 550,
          labelAttributes: {
            prefix: `${getMetricShortName({
              metricKey: metricKeys.VideoStartFailures,
              hasSubscript: false,
            })}, ${getMetricShortName({
              metricKey: metricKeys.VideoStartTime,
              hasSubscript: false,
            })}, ${getMetricShortName({
              metricKey: metricKeys.ExitBeforeVideoStarts,
              hasSubscript: false,
            })}`,
            suffix: getMetricDisplayName({
              metricKey: metricKeys.Attempts,
            }),
          },
          hideConvivaInput: false,
        },
        {
          key: keys.RebufferingRatio.key,
          width: 600,
          labelAttributes: {
            prefix: `${getMetricShortName({
              metricKey: metricKeys.ConnectionInducedRebufferingRatio,
              hasSubscript: false,
            })}, RR, BR, FR`,
            suffix: getMetricDisplayName({
              metricKey: metricKeys.ConcurrentPlays,
            }),
          },
          hideConvivaInput: false,
        },
        {
          key: keys.VideoPlaybackFailures.key,
          width: 550,
          labelAttributes: {
            prefix: getMetricShortName({
              metricKey: metricKeys.VideoPlaybackFailures,
            }),
            suffix: getMetricDisplayName({
              metricKey: metricKeys.EndedPlays,
            }),
          },
          hideConvivaInput: false,
        },
      ],
    },
    AI: {
      cols: [
        {
          key: adKeys.adCombinedMetricsBundleOne.key,
          width: 650,
          labelAttributes: {
            prefix: adKeys.adCombinedMetricsBundleOne.displayName,
            suffix: getMetricDisplayName({
              metricKey: metricKeys.ConcurrentPlays,
            }),
          },
          hideConvivaInput: false,
        },
        {
          key: adKeys.adCombinedMetricsBundleTwo.key,
          width: 550,
          labelAttributes: {
            prefix: adKeys.adCombinedMetricsBundleTwo.displayName,
            suffix: getMetricDisplayName({
              metricKey: metricKeys.Attempts,
            }),
          },
          hideConvivaInput: false,
        },
        {
          key: adKeys.adCombinedMetricsBundleThree.key,
          width: 700,
          labelAttributes: {
            prefix: adKeys.adCombinedMetricsBundleThree.displayName,
            suffix: getMetricDisplayName({
              metricKey: metricKeys.AdImpressions,
            }),
          },
          hideConvivaInput: false,
        },
      ],
    },
    APP: {
      cols: [
        {
          title: '',
          key: metricKeys.AppAvgPageLoadTime,
          width: 400,
          labelAttributes: { prefix: 'Avg Page Load Time', suffix: 'Page Load Complete' },
          hideConvivaInput: false,
        },
        {
          title: '',
          key: metricKeys.AppAvgScreenLoadTime,
          width: 400,
          labelAttributes: { prefix: 'Avg Screen Load Time', suffix: 'Screen Loads' },
          hideConvivaInput: false,
        },
        {
          title: '',
          key: metricKeys.AverageRequestDuration,
          width: 400,
          labelAttributes: {
            prefix: 'Avg Network Request Duration',
            suffix: 'Network Request Count',
          },
          hideConvivaInput: false,
        },
        {
          title: '',
          key: metricKeys.AppUniqueDevices,
          width: 400,
          labelAttributes: { prefix: 'Active Devices', suffix: 'Active Devices' },
          hideConvivaInput: false,
        },
      ],
    },
  })[CURRENT_PRODUCT_MODE];

const getThresholdTechErrorBaselineColumns = () =>
  ({
    EI: {
      cols: [
        {
          key: keys.eicombinedMetrics.key,
          width: 550,
          labelAttributes: {
            prefix: `${getMetricShortName({
              metricKey: metricKeys.VideoStartFailures,
              hasSubscript: false,
            })}, ${getMetricShortName({
              metricKey: metricKeys.VideoStartTime,
              hasSubscript: false,
            })}, ${getMetricShortName({
              metricKey: metricKeys.ExitBeforeVideoStarts,
              hasSubscript: false,
            })}`,
            suffix: getMetricDisplayName({
              metricKey: metricKeys.Attempts,
            }),
          },
          hideConvivaInput: false,
        },
        {
          key: keys.RebufferingRatio.key,
          width: 600,
          labelAttributes: {
            prefix: `${getMetricShortName({
              metricKey: metricKeys.ConnectionInducedRebufferingRatio,
              hasSubscript: false,
            })}, RR, BR, FR`,
            suffix: getMetricDisplayName({
              metricKey: metricKeys.ConcurrentPlays,
            }),
          },
          hideConvivaInput: false,
        },
        {
          key: keys.VideoPlaybackFailuresTech.key,
          width: 550,
          labelAttributes: {
            prefix: getMetricShortName({
              metricKey: metricKeys.VideoPlaybackFailuresTech,
              hasSubscript: false,
            }),
            suffix: getMetricDisplayName({
              metricKey: metricKeys.EndedPlays,
            }),
          },
          hideConvivaInput: false,
        },
      ],
    },
    AI: {
      cols: [
        {
          key: adKeys.adCombinedMetricsBundleOne.key,
          width: 650,
          labelAttributes: {
            prefix: adKeys.adCombinedMetricsBundleOne.displayName,
            suffix: getMetricDisplayName({
              metricKey: metricKeys.ConcurrentPlays,
            }),
          },
          hideConvivaInput: false,
        },
        {
          key: adKeys.adCombinedMetricsBundleTwo.key,
          width: 550,
          labelAttributes: {
            prefix: adKeys.adCombinedMetricsBundleTwo.displayName,
            suffix: getMetricDisplayName({
              metricKey: metricKeys.Attempts,
            }),
          },
          hideConvivaInput: false,
        },
        {
          key: adKeys.adCombinedMetricsBundleThree.key,
          width: 700,
          labelAttributes: {
            prefix: adKeys.adCombinedMetricsBundleThree.displayName,
            suffix: getMetricDisplayName({
              metricKey: metricKeys.AdImpressions,
            }),
          },
          hideConvivaInput: false,
        },
      ],
    },
    APP: {
      cols: [
        {
          title: '',
          key: metricKeys.AppAvgPageLoadTime,
          width: 400,
          labelAttributes: { prefix: 'Avg Page Load Time', suffix: 'Page Load Complete' },
          hideConvivaInput: false,
        },
        {
          title: '',
          key: metricKeys.AppAvgScreenLoadTime,
          width: 400,
          labelAttributes: { prefix: 'Avg Screen Load Time', suffix: 'Screen Loads' },
          hideConvivaInput: false,
        },
        {
          title: '',
          key: metricKeys.AverageRequestDuration,
          width: 400,
          labelAttributes: {
            prefix: 'Avg Network Request Duration',
            suffix: 'Network Request Count',
          },
          hideConvivaInput: false,
        },
        {
          title: '',
          key: metricKeys.AppUniqueDevices,
          width: 400,
          labelAttributes: { prefix: 'Active Devices', suffix: 'Active Devices' },
          hideConvivaInput: false,
        },
      ],
    },
  })[CURRENT_PRODUCT_MODE];

const THRESHOLD_MAIN_COLUMNS = {
  EI: {
    cols: [
      {
        key: keys.ExitBeforeVideoStarts.key,
        hideConvivaInput: false,
      },
      {
        key: keys.RebufferingRatio.key,
        hideConvivaInput: false,
      },
      {
        key: keys.VideoStartTime.key,
        hideConvivaInput: false,
      },
      {
        key: keys.ConnectionInducedRebufferingRatio.key,
        hideConvivaInput: false,
      },
      {
        key: keys.ConcurrentPlays.key,
        hideConvivaInput: true,
      },
      {
        key: keys.Framerate.key,
        hideConvivaInput: true,
      },
      {
        key: keys.Bitrate.key,
        hideConvivaInput: true,
      },
    ],
  },
  AI: {
    cols: [
      {
        key: adKeys.RebufferingRatio.key,
        hideConvivaInput: false,
      },
      {
        key: adKeys.Bitrate.key,
        hideConvivaInput: false,
      },
      {
        key: adKeys.VideoStartFailuresPercentage.key,
        hideConvivaInput: false,
      },
      {
        key: adKeys.VideoStartTime.key,
        hideConvivaInput: false,
      },
      {
        key: adKeys.AdSlateDurationPct.key,
        hideConvivaInput: false,
      },
      {
        key: adKeys.AdSlatePlaysPct.key,
        hideConvivaInput: false,
      },
    ],
  },
  APP: {
    cols: [],
  },
};

const THRESHOLD_TECHNICAL_ERROR_COLUMNS = {
  EI: {
    cols: [
      {
        key: keys.VideoPlaybackFailuresTech.key,
        hideConvivaInput: false,
      },
      {
        key: keys.VideoStartFailuresTech.key,
        hideConvivaInput: false,
      },
    ],
  },
  AI: {
    cols: [],
  },
  APP: {
    cols: [],
  },
};

const THRESHOLD_ERROR_COLUMNS = {
  EI: {
    cols: [
      {
        key: keys.VideoStartFailures.key,
        hideConvivaInput: false,
      },
      {
        key: keys.VideoPlaybackFailures.key,
        hideConvivaInput: false,
      },
    ],
  },
  AI: {
    cols: [],
  },
  APP: {
    cols: [],
  },
};

const getThresholdMainColumns = () => THRESHOLD_MAIN_COLUMNS[CURRENT_PRODUCT_MODE];
const getThresholdMetrics = () =>
  THRESHOLD_MAIN_COLUMNS[CURRENT_PRODUCT_MODE].cols.map((column) => column.key);
const getThresholdTechErrorMetrics = () => THRESHOLD_TECHNICAL_ERROR_COLUMNS[CURRENT_PRODUCT_MODE];
const getThresholdErrorMetrics = () => THRESHOLD_ERROR_COLUMNS[CURRENT_PRODUCT_MODE];

export {
  getThresholdBaselineColumns,
  getThresholdMainColumns,
  getThresholdMetrics,
  getThresholdTechErrorMetrics,
  getThresholdErrorMetrics,
  getThresholdTechErrorBaselineColumns,
};
